import ResultsFormatterBase from "../../formatters/ResultsFormatterBase.js";
import ResultFormatterBase from "../ResultFormatterBase.js";

class BatchResultsFormatter extends ResultsFormatterBase{
    constructor(resultFormatter) {
        super();

        if (!(resultFormatter instanceof ResultFormatterBase)){
            throw new TypeError('resultFormatter must be an instance inheriting from ResultFormatterBase');
        }

        this.resultFormatter = resultFormatter;
    }

    format(results) {
        for (let i = 0; i < results.length; i++){
            results[i] = this.resultFormatter.format(results[i]);
        }

        return results;
    }
};

export default BatchResultsFormatter;